/**
 * Advanced Search Adapter for AuditLogs
 * Transforms field registry to TableSearch field configurations
 */

import { FieldConfig } from '../../../components/TableSearch/types';
import { BaseFieldDefinition } from '../../../shared/types/fieldRegistry';
import { AUDIT_LOGS_FIELDS_REGISTRY } from '../fields';
import { AuditLog } from '../../../services/api/domains/audit/types';

/**
 * Transform a field definition to search field configuration
 */
function toSearchFieldConfig(
  field: BaseFieldDefinition<AuditLog>
): FieldConfig {
  // Convert boolean to selection, cast other types
  const dataType =
    field.dataType === 'boolean'
      ? 'selection'
      : field.dataType === 'object'
        ? 'string'
        : (field.dataType as 'string' | 'number' | 'date' | 'selection');

  const config: FieldConfig = {
    key: field.key,
    label: field.label,
    dataType,
  };

  // Add selection options if available in field registry
  if (field.selectionOptions && field.selectionOptions.length > 0) {
    config.options = field.selectionOptions;
  }

  return config;
}

/**
 * Transform field registry to advanced search field configurations
 */
export function toAuditLogsSearchConfig(): FieldConfig[] {
  const searchFields = AUDIT_LOGS_FIELDS_REGISTRY.filter(f => f.isSearchable);
  return searchFields.map(toSearchFieldConfig);
}

/**
 * Get array of searchable field keys for validation
 */
export function getSearchableFieldKeys(): string[] {
  return AUDIT_LOGS_FIELDS_REGISTRY.filter(f => f.isSearchable).map(f => f.key);
}
